import { BooleanTags } from "../../components/common/registerUtils";
import { createColumn, formatCurrency } from "../../utils/helpers";

export const useAccountAlerts = () => {
  const tableColumns = () => [
    createColumn("account", true, "Account"),
    createColumn("name", true, "Name"),
    createColumn("balance", true, "Balance"),
    createColumn("alert_status", false, "Alert Status"),
    createColumn("comment", true, "Comment"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        balance: formatCurrency(item?.balance),
        alert_status: <BooleanTags status={item?.alert_status} />,
        comment: (
          <span style={{ color: item?.alert_status ? "red" : "green" }}>
            {item?.comment}
          </span>
        ),
      };
    }),
  ];

  return { tableColumns, tableData };
};
